module.exports = __webpack_public_path__ + "static/media/cross-white.4e62fbd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cross-white.svg
// module id = 340
// module chunks = 0